import { Helmet } from 'react-helmet';

interface SchemaMarkupProps {
  schema: object | object[];
}

export const SchemaMarkup = ({ schema }: SchemaMarkupProps) => {
  const schemaArray = Array.isArray(schema) ? schema : [schema];
  
  return (
    <Helmet>
      {schemaArray.map((schemaItem, index) => (
        <script 
          key={index} 
          type="application/ld+json"
          dangerouslySetInnerHTML={{ __html: JSON.stringify(schemaItem) }}
        />
      ))}
    </Helmet>
  );
};
